import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import InputUI from '../../components/UI/InputUI';
import Select from '../../components/UI/Select';
import ButtonUI from '../../components/UI/ButtonUI';
import LabelUI from '../../components/UI/LabelUI';
import { translate, isNullOrEmpty, showMessageToastCustom } from '../../utils/util';
import { onValueChange } from '../../utils/handleChangeHooks';
import VolumeService from '../../services/VolumeService';

const ConfirmationVolume = (props) => {
    const [packing, setPacking] = useState({});

    useEffect(() => {
        if (props.packing?.items?.length > 0 && props.volumeConfiguration.packingId > 0) {
            const data = props.packing.items.find((f) => f.rackCodeId === props.volumeConfiguration.packingId);
            setPacking(data);
        }
        // eslint-disable-next-line
    }, [props.volumeConfiguration]);

    useEffect(() => {
        packing.grossWeightTotal = props.grossWeight;
        document.getElementById("grossWeightTotal").value = packing.grossWeightTotal;

        // eslint-disable-next-line
    }, [props.grossWeight]);

    const formatDescriptionMdr = (item) => {
        const descriptionItem = !isNullOrEmpty(item.codEmbalagemIRF) ? item.codEmbalagemIRF : item.code || '';
        return !isNullOrEmpty(descriptionItem) ? `${descriptionItem}-${item.description}` : ''
    }

    const onChange = (event) => {
        onValueChange(event, packing, setPacking);
    };

    const onWeightChange = (event) => {
        onValueChange(event, packing, setPacking);
        document.getElementById("weight").value = parseFloat(event.target.value - props.netWeight).toFixed(2);
        packing.weight = parseFloat(event.target.value - props.netWeight).toFixed(2);
    };

    const confirmVolume = () => {
        if (isNullOrEmpty(packing.tipoVolume) || isNullOrEmpty(packing.weight)) {
            showMessageToastCustom(translate('warning', 'general'), translate('obligatory-fields', 'volume'), 3000, 'mdi mdi-alert-circle-outline red-text');
            return;
        }

        if (props.volumeItems.length === 0) {
            showMessageToastCustom(translate('warning', 'general'), translate('no-cartellino', 'volume'), 3000, 'mdi mdi-alert-circle-outline red-text');
            return;
        }

        if (props.volumeRegistrations.length === 0 && props.volumeConfiguration.registrationRequired) {
            showMessageToastCustom(translate('warning', 'general'), translate('no-registration', 'volume'), 3000, 'mdi mdi-alert-circle-outline red-text');
            return;
        }

        const sumVolumeItems = props.volumeItems.reduce((sum, item) => sum += item.quantidadeUtilizada, 0);
        if (sumVolumeItems !== props.volumeRegistrations.length && props.volumeConfiguration.registrationRequired) {
            showMessageToastCustom(translate('warning', 'general'), translate('registration-cartellino-number', 'volume').replace('qtCartellino', sumVolumeItems).replace('qtMatricula', props.volumeRegistrations.length), 3000, 'mdi mdi-alert-circle-outline red-text');
            return;
        }

        if (isNullOrEmpty(packing.grossWeightTotal) || packing.grossWeightTotal === 0) {
            showMessageToastCustom(translate('warning', 'general'), translate('gross-weight', 'volume'), 3000, 'mdi mdi-alert-circle-outline red-text');
            return;
        }

        const volume = {
            referenceDate: props.volumeConfiguration.date,
            marketCode: props.volumeConfiguration.marketplaceId,
            mdrNumber: props.volumeConfiguration.packingId,
            type: packing.tipoVolume,
            tare: packing.weight,
            totalWeight: packing.grossWeightTotal,
            TotalNetWeight: props.netWeight,
            volumeItem: props.volumeItems,
            volumeSerialNumber: props.volumeRegistrations
        }
        props.createVolume(volume, () => {
            props.clear();
            props.setTable(3);
            props.onSelectedTab(3, true);
        });
    }

    return (
        <div className="container">
            <div className="row">
                <div className="card-content" style={{ padding: '7px', paddingBlockEnd: '1px', backgroundColor: 'white' }}>
                    <fieldset className='fieldset'>
                        <legend style={{ padding: '0 5px' }}>`${translate('physical-confirmation:mdr')}</legend>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            <LabelUI class="col s12" id="description" label={translate('volume.description')} value={formatDescriptionMdr(packing)} />
                            <LabelUI class="col s5" id="m3" label={translate('volume.cubage')} value={packing?.m3} />
                            <LabelUI class="col s5" id="length" label={translate('volume.length')} value={packing?.length} />
                            <LabelUI class="col s5" id="height" label={translate('volume.height')} value={packing?.height} />
                            <LabelUI class="col s5" id="width" label={translate('volume.widht')} value={packing?.width} />
                            <LabelUI class="col s5" id="weight" label={translate('volume.tare')} value={packing?.weight} />
                        </div>
                    </fieldset>
                    <fieldset className='fieldset'>
                        <legend style={{ padding: '0 5px' }}>{translate('total-gross-weight', 'volume')}</legend>
                        <form>
                            <div className="no-padding col s11" style={{ marginLeft: '13px' }} >
                                <Select
                                    required
                                    id="tipoVolume"
                                    name="tipoVolume"
                                    label={translate('volume.type')}
                                    defaultValue={packing?.tipoVolume || ''}
                                    change={onChange}
                                    placeHolder={translate("select-type", "volume")}
                                    data={[{ id: 1, text: translate('volume:volumeType.box') }, { id: 2, text: translate('volume:volumeType.container') }]}
                                />
                            </div>
                            <div className="input-field no-padding col s6" style={{ marginLeft: '13px' }}>
                                <InputUI
                                    required
                                    onChange={onWeightChange}
                                    defaultValue={packing?.grossWeightTotal || ''}
                                    label={translate('total-gross-weight', 'volume')}
                                    id="grossWeightTotal"
                                    name="grossWeightTotal"
                                    type="number"
                                />
                            </div>
                        </form>
                    </fieldset>
                </div>
                <div className="col s12 center" style={{ paddingTop: '10px' }}>
                    <ButtonUI onClick={() => confirmVolume()} full="true" text={translate('create-volume', 'volume')} />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        volumeItems: state.volumeReducer.volumeItems,
        volumeRegistrations: state.volumeReducer.volumeRegistrations,
        packing: state.volumeReducer.packing,
        volumeConfiguration: state.volumeReducer.volumeConfiguration,
        grossWeight: state.volumeReducer.grossWeight,
        netWeight: state.volumeReducer.netWeight,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createVolume: (item, callback) => {
            dispatch(VolumeService.createVolume(item, callback));
        },
        clear: () => {
            dispatch(VolumeService.clear());
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmationVolume));
